import { render } from "./Dropdown.vue?vue&type=template&id=3f6f6474"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/sbimh.nl/tickets.sbimh.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__